import { deleteTemplate, getByIdTemplate, getTemplate, newTemplate, patchTemplate } from "../reqTemplate";

var ROUTE_URL = 'trainingPlan';

export const getAllTrainingPlan = async () => {
  return await getTemplate(ROUTE_URL);
}; 

export const getTrainingPlanById = async (id) => {
  return await getByIdTemplate(`/${ROUTE_URL}/${id}`);
};

export const newTrainingPlan = async (payload) => {
  console.log('newExercise', payload)
  return await newTemplate(ROUTE_URL, payload);
};

export const deleteTrainingPlan = async (id) => {
  return await deleteTemplate(`/${ROUTE_URL}/${id}`);
};

export const patchTrainingPlan = async (id, payload) => {
  return await patchTemplate(`/${ROUTE_URL}/${id}`, payload);
};
